import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import { logout } from "../../../store/Actions/authActions";
import { ResultScreen } from "../Feedback";
import { Icon, OnboardingIcons } from "../OnboardingLayout";

const ILLUSTRATION = "/assets/imgs/illustration-succes.png";

/**
 * Écran de succès qui close les parcours d'adresse (design « Pop-ups et
 * confirmations », écran 02). Trois issues suivant d'où l'on vient :
 * fin d'inscription, proposition d'un nouveau point, ou ajout d'adresse.
 */
class ThankYou extends React.Component {
  get state_() {
    return this.props.history?.location?.state || {};
  }

  handleLogout = () => {
    this.props.logout(this.props);
  };

  render() {
    const { t } = this.props;
    const { myLove, add } = this.state_;

    /* Fin d'inscription : l'utilisateur enchaîne sur sa première commande. */
    if (myLove === "Pakistan") {
      return this.screen({
        badge: t("Registration complete"),
        title: t("Congratulations!"),
        lede: t(
          "Your registration is complete. You can place your first order right away."
        ),
        actions: [
          {
            label: t("Home Page"),
            onClick: () => this.props.history.push("/home"),
          },
          {
            label: t("Place an order"),
            primary: true,
            onClick: () => this.props.history.push("/home"),
          },
        ],
      });
    }

    /* Proposition d'un nouveau point de collecte : l'équipe reprend la main. */
    if (add) {
      return this.screen({
        badge: t("Request sent"),
        title: t("Success!"),
        lede: t(
          "Your submission has been received, and our team will make it a priority to get in touch with you as soon as possible."
        ),
        actions: [
          { label: t("Back to login"), primary: true, onClick: this.handleLogout },
        ],
      });
    }

    /* Cas courant : une adresse ou un point de collecte vient d'être ajouté. */
    return this.screen({
      badge: t("Address saved"),
      title: t("Congratulation!"),
      lede: t(
        "Your address has been saved. You can place your first order right away."
      ),
      actions: [
        {
          label: t("Back to home"),
          onClick: () => this.props.history.push("/home"),
        },
        {
          label: t("Place an order"),
          primary: true,
          onClick: () => this.props.history.push("/home"),
        },
      ],
    });
  }

  screen({ badge, title, lede, actions }) {
    return (
      <>
        <OnboardingIcons />
        <ResultScreen
          tone="success"
          illustration={ILLUSTRATION}
          badge={
            <>
              <Icon name="check" />
              {badge}
            </>
          }
          title={title}
          lede={lede}
          actions={actions}
        />
      </>
    );
  }
}

export default compose(withTranslation(), connect(null, { logout }))(ThankYou);
